import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { StoreHomeComponent } from './store-home/store-home.component';
import { AddProductCartComponent } from './add-product-cart/add-product-cart.component';
import { StoreCartComponent } from './store-cart/store-cart.component';
import { StoreMasterLayoutComponent } from './store-master-layout/store-master-layout.component';
import { CustomerDetailComponent } from './customer-detail/customer-detail.component';
import { StoreCheckOutComponent } from './store-check-out/store-check-out.component';
import { ThankYouComponent } from './thank-you/thank-you.component';
import { StoreUrlNotFoundComponent } from './store-url-not-found/store-url-not-found.component'

const routes: Routes = [
  {
    path: '', component: StoreMasterLayoutComponent,
    children: [{ path: '', component: StoreHomeComponent }]

  },
  {
    path: '', component: StoreMasterLayoutComponent,
    children: [{ path: 'view-product', component: AddProductCartComponent }]

  },
  {
    path: '', component: StoreMasterLayoutComponent,
    children: [{ path: 'cart', component: StoreCartComponent }]

  },
  {
    path: '', component: StoreMasterLayoutComponent,
    children: [{ path: 'cutomer-detail', component: CustomerDetailComponent }]

  },
  {
    path: '', component: StoreMasterLayoutComponent,
    children: [{ path: 'payment', component: StoreCheckOutComponent }]

  },
  {
    path: '', component: StoreMasterLayoutComponent,
    children: [{ path: 'thank-you', component: ThankYouComponent }]

  },
  {
    path: '',
    children: [{ path: 'not-found', component: StoreUrlNotFoundComponent }]
  },
  {
    path: ':order_id', component: StoreMasterLayoutComponent,
    children: [{ path: 'thank-you', component: ThankYouComponent }]

  }

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class MntStoreProductRoutingModule { }



// WEBPACK FOOTER //
// /var/www/login.theprintlife.com/src/app/mnt-store-product/mnt-store-product-routing.module.ts